import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { AdminErrorBoundary } from './components/common/AdminErrorBoundary';
import { ToastProvider } from './components/ui';
import { captureError, initErrorReporting } from './services/errorReporting';
import './i18n';
import App from './App';
import './index.css';

initErrorReporting();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

window.addEventListener('error', event => {
  captureError(event.error || event.message, {
    source: 'window-error-event',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

window.addEventListener('unhandledrejection', event => {
  captureError(event.reason, {
    source: 'unhandled-promise-rejection',
  });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <AdminErrorBoundary>
              <App />
            </AdminErrorBoundary>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
